export const getDesignersListData = ({ state }) => state.reports.designersListData;
